
import { toRefs } from 'vue'
export default {
  name: 'TableSelectInfo',
  props: {
    total: {
      type: Number,
      default: 0
    }
  },
  emits: ['clearSelected'],
  setup (props) {
    return {
      ...toRefs(props)
    }
  }
}
